/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * ガス契約使用量情報
 */
export interface Szma301aResGasContractEmpamtDto {
    /**
     * 契約使用量種別コード
     */
    ctrEmpamtClscode?: string;
    /**
     * 契約使用量種別コード名称
     */
    contractusageClsfyCodeaname?: string;
    /**
     * 表示順
     */
    hyojiTurn?: string;
    /**
     * 使用量
     */
    elecCsp?: string;
    /**
     * 使用量単位コード
     */
    empamtUnitCode?: string;
    /**
     * 使用量単位コード名称
     */
    enmploymentpositionaimChangeflag?: string;
}

